export default "__VITE_ASSET__WRma_GvQ__"